import axios from 'axios';

// Create axios instance with base configuration
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3012/api',
  timeout: 30000, // Increased timeout to 30 seconds
  withCredentials: true, // Enable credentials for CORS
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and send the session back to its own login page
      const isVendor = localStorage.getItem('actorType') === 'vendor';
      localStorage.removeItem('token');
      localStorage.removeItem('userEmail');
      window.location.href = isVendor ? '/vendor-login' : '/login';
    }
    
    // Handle inactive account
    if (error.response?.status === 403 && 
        error.response?.data?.message?.includes('deactivated')) {
      // Clear token and redirect to login with message
      localStorage.removeItem('token');
      localStorage.removeItem('userEmail');
      localStorage.setItem('loginMessage', 'Your account has been deactivated. Please contact an administrator.');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;